import React, { Component } from "react";
import { Route } from "react-router-dom";

const DashboardLayout = ({ children, ...rest }) => {
  return (
    <div className="page page-dashboard">
      
      <div className="main">{children}</div>
    </div>
  );
};

const DashboardLayoutRoute = ({ component: Component, children, ...rest }) => {
  if (children) {
    // When children are provided, render them directly without Route wrapper
    return <DashboardLayout>{children}</DashboardLayout>;
  }
  
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <DashboardLayout>
          <Component {...matchProps} />
        </DashboardLayout>
      )}
    />
  );
};

export default DashboardLayoutRoute;
